import { useMemo, useState } from "react";
import { format, parseISO } from "date-fns";
import { api, errMsg } from "@/lib/api";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { CalendarX } from "lucide-react";

export default function BlockDatesDialog({ listing, onDone }) {
  const [open, setOpen] = useState(false);
  const [days, setDays] = useState((listing.blocked_dates || []).map((d) => parseISO(d)));
  const booked = useMemo(() => new Set(listing.booked_dates || []), [listing.booked_dates]);
  const disabled = useMemo(() => [{ before: new Date() }, (d) => booked.has(format(d, "yyyy-MM-dd"))], [booked]);
  const save = async () => {
    try {
      await api.put(`/listings/${listing.listing_id}/blocked-dates`, { dates: days.map((d) => format(d, "yyyy-MM-dd")) });
      toast.success("Calendar updated");
      setOpen(false);
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="rounded-full" data-testid={`block-dates-open-${listing.listing_id}`}><CalendarX className="mr-1 h-4 w-4" />Block dates</Button>
      </DialogTrigger>
      <DialogContent className="max-w-fit">
        <DialogHeader>
          <DialogTitle>Block dates</DialogTitle>
          <DialogDescription>Tap nights to block or unblock them. Booked nights can't be changed.</DialogDescription>
        </DialogHeader>
        <Calendar mode="multiple" selected={days} onSelect={(v) => setDays(v || [])} numberOfMonths={2}
          disabled={disabled} data-testid="block-dates-calendar" />
        <p className="text-sm text-stone-600" data-testid="block-dates-count">{days.length} night{days.length === 1 ? "" : "s"} blocked</p>
        <Button onClick={save} className="rounded-full" data-testid="block-dates-save">Save calendar</Button>
      </DialogContent>
    </Dialog>
  );
}
